const normalize = (value) => String(value || '').trim().toLowerCase();

const AUTOMATIC_STATUSES = new Set(['auto_matched', 'confirmed']);
const CANDIDATE_STATUSES = new Set(['candidate']);
const EQUIPMENT_SOURCES = new Set([
  'bike',
  'elliptical',
  'equipment',
  'rowing_machine',
  'smart_trainer',
  'stationary_bike',
  'treadmill',
  'wahoo',
  'zwift',
]);

export const isAutomaticSyncedWorkoutMatch = (match = {}) => AUTOMATIC_STATUSES.has(normalize(match.match_status));

export const isCandidateSyncedWorkoutMatch = (match = {}) => CANDIDATE_STATUSES.has(normalize(match.match_status));

export const syncedWorkoutSourceKey = (source) => {
  const normalized = normalize(source);
  if (normalized === 'health_connect' || normalized === 'android_health') {
    return 'connectedTraining.syncedWorkoutSourceHealthConnect';
  }
  if (normalized === 'apple_health' || normalized === 'apple_watch') {
    return 'connectedTraining.syncedWorkoutSourceAppleHealth';
  }
  if (EQUIPMENT_SOURCES.has(normalized)) {
    return 'connectedTraining.syncedWorkoutSourceEquipment';
  }
  return 'connectedTraining.syncedWorkoutSourceWearable';
};

export const syncedWorkoutConfidenceKey = (confidence) => {
  const normalized = normalize(confidence);
  if (normalized === 'high') return 'connectedTraining.syncedWorkoutConfidenceHigh';
  if (normalized === 'medium') return 'connectedTraining.syncedWorkoutConfidenceMedium';
  return 'connectedTraining.syncedWorkoutConfidenceLow';
};

export const syncedWorkoutCompletionSourceKey = (completionSource) => {
  const normalized = normalize(completionSource);
  if (normalized === 'synced_equipment') return 'connectedTraining.syncedWorkoutCompletionSyncedEquipment';
  if (normalized === 'manual_fallback') return 'connectedTraining.syncedWorkoutCompletionManualFallback';
  if (normalized === 'estimated') return 'connectedTraining.syncedWorkoutCompletionEstimated';
  return 'connectedTraining.syncedWorkoutCompletionSyncedHealthSource';
};

export const syncedWorkoutMatchStatusKey = (match = {}) => {
  if (isAutomaticSyncedWorkoutMatch(match)) return 'connectedTraining.syncedWorkoutAutoCompleted';
  if (isCandidateSyncedWorkoutMatch(match)) return 'connectedTraining.syncedWorkoutCandidateFound';
  return 'connectedTraining.syncedWorkoutCandidateFound';
};

export const summarizeSyncedWorkoutMatches = (matches = []) => {
  const safeMatches = Array.isArray(matches) ? matches.filter(Boolean) : [];
  const automatic = safeMatches.filter(isAutomaticSyncedWorkoutMatch);
  const candidates = safeMatches.filter(isCandidateSyncedWorkoutMatch);
  const latest = safeMatches[0] || null;
  return {
    totalCount: safeMatches.length,
    automaticCount: automatic.length,
    candidateCount: candidates.length,
    latest,
    hasMatches: safeMatches.length > 0,
  };
};

export const findSyncedMatchForPrescription = (prescription = {}, matches = []) => {
  if (!prescription?.id || !Array.isArray(matches)) return null;
  return matches.find((match) => match?.workout_prescription_id === prescription.id) || null;
};

export const syncedWorkoutCopyKeys = () => [
  'connectedTraining.syncedWorkoutMatchesTitle',
  'connectedTraining.syncedWorkoutMatchesBody',
  'connectedTraining.syncedWorkoutAutoCompleted',
  'connectedTraining.syncedWorkoutCandidateFound',
  'connectedTraining.syncedWorkoutNoMatches',
  'connectedTraining.syncedWorkoutManualFallbackNote',
];
